<div class="card card-box mb-5">
    <div class="row no-gutters">
        <div class="col-xl-5">
            <div class="p-4 text-center">
                <div class="avatar-icon-wrapper rounded-circle mx-auto">
                    <div class="d-block p-0 avatar-icon-wrapper rounded-circle m-0 border-3 border-first">
                        <div class="rounded-circle border-3 border-white overflow-hidden">
                            <img alt="..." class="img-fluid" src="assets/images/avatars/avatar5.jpg"/>
                        </div>
                    </div>
                </div>
                <h4 class="font-size-lg font-weight-bold my-2">
                    Marion Devine
                </h4>
                <div class="text-center my-4">
                <span class="badge badge-pill bg-neutral-first text-first mx-1">
                    Web developer
                </span>
                    <span class="badge badge-pill bg-neutral-warning text-warning mx-1">
                    Javascript
                </span>
                    <span class="badge badge-pill bg-neutral-danger text-danger mx-1">
                    Angular
                </span>
                </div>

                <p class="text-muted mb-4">I should be incapable of drawing a single stroke at the present moment; and
                    yet I feel
                    that I never was a greater artist than now.</p>

                <div class="divider my-4"></div>
                <div class="row">
                    <div class="col-md-6">
                        <span class="opacity-6 pb-2">Current month</span>
                        <div class="d-flex align-items-center justify-content-center">
                        <span class="font-weight-bold font-size-lg">
                            <small class="opacity-6">$</small>
                            46,362
                        </span>
                            <span class="badge bg-neutral-danger ml-2 text-danger">-8%</span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <span class="opacity-6 pb-2">Last year</span>
                        <div class="d-flex align-items-center justify-content-center">
                        <span class="font-weight-bold font-size-lg">
                            <small class="opacity-6">$</small>
                            34,546
                        </span>
                            <span class="badge bg-neutral-success ml-2 text-success">+13%</span>
                        </div>
                    </div>
                </div>
                <div class="divider my-4"></div>
                <div class="font-weight-bold text-uppercase text-black-50 text-center mb-3">
                    Team members
                </div>
                <div class="avatar-wrapper-overlap d-flex justify-content-center mb-3">
                    <div class="avatar-icon-wrapper" containerClass="tooltip-danger" tooltip="Chelsey Delaney">
                        <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar1.jpg"/></div>
                    </div>
                    <div class="avatar-icon-wrapper" containerClass="tooltip-first" tooltip="Laibah Santos">
                        <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar7.jpg"/></div>
                    </div>
                    <div class="avatar-icon-wrapper" containerClass="tooltip-second" tooltip="Ksawery Weber">
                        <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar1.jpg"/></div>
                    </div>
                    <div class="avatar-icon-wrapper" containerClass="tooltip-info" tooltip="Killian Magana">
                        <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar2.jpg"/></div>
                    </div>
                    <div class="avatar-icon-wrapper" containerClass="tooltip-success" tooltip="Kean Banks">
                        <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar6.jpg"/></div>
                    </div>
                </div>
                <div class="divider my-4"></div>
                <button class="btn btn-outline-first mt-2" type="button">
                    View complete profile
                </button>
            </div>
        </div>
        <div class="col-xl-7">
            <div class="hero-wrapper bg-composed-wrapper h-100 rounded-right">
                <div class="flex-grow-1 w-100 d-flex align-items-end">
                    <div class="bg-composed-wrapper--image rounded-right opacity-9 bg-composed-filter-rm"
                         style="background-image: url('assets/images/stock-photos/people-3.jpg');"></div>
                    <div class="bg-composed-wrapper--content text-center p-5">
                        <div class="text-white mt-3">
                            <h1 class="display-3 my-3 font-weight-bold">
                                Wonderful serenity has possession
                            </h1>
                            <p class="font-size-lg mb-0 text-white-50">
                                A free hour, when our power of choice is untrammelled and when nothing prevents.
                            </p>
                            <div class="divider border-1 mx-auto my-4 border-light opacity-2 rounded w-25"></div>
                            <div>
                                <a [routerLink]="" class="btn btn-success btn-lg btn-pill">
                                    <span class="btn-wrapper--icon">
                                        <fa-icon [icon]="['far', 'envelope']"></fa-icon>
                                    </span>
                                    <span class="btn-wrapper--label">
                                        Get in touch
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
